"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.05;
  return <section className="relative min-h-screen w-full overflow-hidden">
      {}
      <div className="fixed inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1474184/img/image_fmienjzr.webp)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }} />

      {}
      <div className="fixed inset-0 bg-dark-background/40" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-20">
        <div ref={ref} className={`max-w-2xl transform rounded-3xl bg-gradient-to-br from-primary-light via-accent-light to-secondary-light px-8 py-10 shadow-strong backdrop-blur-sm transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] md:px-12 md:py-14 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"} hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.2)]`}>
          <h1 className="text-center font-display text-4xl font-bold leading-tight text-foreground-light md:text-5xl lg:text-6xl">Get in Touch with Texas Margaritas!</h1>
          <p className="mt-6 text-center font-sans text-lg text-foreground-light/90 md:text-xl">
            We'd love to hear from you! Whether you have questions about our menu, want to make a reservation, or just want to say hello, reach out to us.
          </p>
          <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <Link to="tel:317-740-0001" className="btn-primary w-full sm:w-auto">
              Call Us Now
            </Link>
            <Link to="mailto:Texasmargaritascarmel@gmail.com" className="inline-flex w-full items-center justify-center rounded-md bg-secondary px-6 py-3 font-semibold text-foreground-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:bg-secondary-hover hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent active:translate-y-0 active:bg-secondary-active sm:w-auto">
              Email Us
            </Link>
          </div>
        </div>
      </div>
    </section>;
}